var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dui-context-menu",class:{ 'center': _vm.side === 'center',
            'left': _vm.side === 'left',
            'open': _vm.vm.isOpen }},[_c('div',{staticClass:"trigger",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.toggleOpen.apply(null, arguments)}}},[_vm._t("trigger")],2),_vm._v(" "),_c('div',{staticClass:"options",style:({ width: _vm.optionsWidth + 'px' })},[_c('span',{staticClass:"tip"}),_vm._v(" "),_vm._t("options")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }